import {observer} from "mobx-react";
import React, {useContext, useState} from "react";
import TableGeneric from "@dropDesk/presentation/components/tables/table_generic";
import HighLightWords from "@dropDesk/presentation/components/high_light_words";
import {MenuCollapsedContext} from "@dropDesk/presentation/routes/private_route";
import {ListPaginationEntity} from "@dropDesk/domain/entities/common/list_pagination.entity";
import {PaymentEntity} from "@dropDesk/domain/entities/payment/payment.entity";
import {displayDateToLocale} from "@dropDesk/utils/helpers/date_helper";
import {formatCurrency} from "@dropDesk/utils/helpers/common";

import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {PaymentSubscriptionEntity} from "@dropDesk/domain/entities/payment_subscriptions/payment_subscription_entity";
import InvoiceView from "@dropDesk/presentation/pages/panel_adm/ui/painel_adm/payments_history/table/invoice_view";
import LabelStatus from "@dropDesk/presentation/pages/panel_adm/ui/painel_adm/payments_history/table/label_status";
import ExternallyPay from "@dropDesk/presentation/pages/panel_adm/ui/painel_adm/payments_history/table/externally_pay";
import RefundPay from "@dropDesk/presentation/pages/panel_adm/ui/painel_adm/payments_history/table/refund_pay";

const TablePaymentsHistory = observer(
    ({
         tablePayments,
         loading,
         getDataFromPagePayments,
         onClickDownloadInvoice,
         onClickExternallyPay,
         onClickRefundPay,
         currentSubscription
     }: {

        tablePayments: ListPaginationEntity<PaymentEntity>,
        loading: boolean
        getDataFromPagePayments: (page: number) => void,
        onClickDownloadInvoice: (payment: PaymentEntity) => void
        onClickExternallyPay: (payment: PaymentEntity) => void
        onClickRefundPay: (payment: PaymentEntity) => void
        currentSubscription: PaymentSubscriptionEntity

    }) => {
        const collapsed = useContext(MenuCollapsedContext);
        const appController = useInjection(AppController);

        const tableColumn = [

            {
                title: 'Código', ellipsis: true, dataIndex: 'id', key: 'id',
                render: (text: string, record: PaymentEntity) => (
                    <HighLightWords
                        searchWords={''}
                        textToHighlight={record.secureCode}
                    />
                ),
            },
            {
                title: 'Valor',
                ellipsis: true,
                dataIndex: 'value',
                key: 'id',
                render: (text: string, record: PaymentEntity) => (
                    <span>{formatCurrency(record.value)}</span>
                ),
            },

            {
                title: 'Pagamento', ellipsis: true, dataIndex: 'billingType', key: 'id',
                render: (text: string, record: PaymentEntity) => (
                    <HighLightWords
                        searchWords={''}
                        textToHighlight={record.paymentLabel}
                    />
                ),
            },
            {
                title: 'Situação',
                ellipsis: true,
                dataIndex: 'status',
                key: 'id',
                render: (text: string, record: PaymentEntity) => (
                    <LabelStatus payment={record} currentSubscription={currentSubscription}/>
                ),
            },
            {
                title: 'Período',
                ellipsis: true,
                dataIndex: 'period',
                key: 'id',
                render: (text: string, record: PaymentEntity) => (
                    <HighLightWords
                        searchWords={''}
                        textToHighlight={record.periodFormatted}
                    />
                ),
            },
            {
                title: 'Criado em', ellipsis: true, dataIndex: 'createdAt', key: 'id', render: (text: string) => (
                    <span>{displayDateToLocale(text)}</span>
                ),
            },
            {
                title: 'Fatura',
                ellipsis: true,
                dataIndex: 'id',
                key: 'id',
                width: 115,
                render: (text: string, record: PaymentEntity) => (
                    <InvoiceView
                        payment={record}
                        onClickDownloadInvoice={onClickDownloadInvoice}
                        currentSubscription={currentSubscription}
                    />
                ),
            },
            {
                title: 'Considerar pago',
                ellipsis: true,
                dataIndex: 'id',
                key: 'id',
                width: 225,
                render: (text: string, record: PaymentEntity) => (
                    <ExternallyPay
                        payment={record}
                        onClickExternallyPay={onClickExternallyPay}
                    />
                ),
            },
            {
                title: 'Estornar',
                ellipsis: true,
                dataIndex: 'id',
                key: 'id',
                width: 115,
                render: (text: string, record: PaymentEntity) => (
                    <RefundPay
                        payment={record}
                        onClickRefundPay={onClickRefundPay}
                    />
                ),
            },
        ];


        return (
            <TableGeneric<PaymentEntity>
                sticky={true}
                size={'small'}
                tableColumns={tableColumn}
                tableDataSource={tablePayments.data}
                loading={loading}
                labelNoResults={'Nenhuma fatura encontrada na pesquisa'}
                collapsedMenu={collapsed}
                defaultCurrentPage={1}
                totalRows={tablePayments.totalRows}
                page={tablePayments.page}
                pageSize={tablePayments.limit}
                rowSelection={null}
                onChange={(page) => getDataFromPagePayments(page - 1)}
                onSelectedRow={(payment) => {
                }}
                hideMenu={!appController.user}
                isChildContainer={true}

            />
        )
    })
export default TablePaymentsHistory;
